import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

const key = CryptoJS.enc.Utf8.parse("12345678901234567890123456789012"); // 32 chars = 256-bit key
const iv = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16 chars = 128-bit IV (fixed)

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

  
function decryptURL(encryptedBase64) {
  try {
    const base64 = decodeURIComponent(encryptedBase64); // decode it first
    const decrypted = CryptoJS.AES.decrypt(base64, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error.message);
    return "";
  }
}

const UpiPaymentPage = () => {
  const query = useQuery();
  const encryptedData = query.get("data") || "";
  console.log("Encrypted Data:", encryptedData);

  const [upiParams, setUpiParams] = useState({
    pa: "",
    pn: "",
    am: "",
    mc: "",
    tr: "",
    tn: "",
    cu: "",
  });

  useEffect(() => {
    if (!encryptedData) return;

    // Decrypt the full URL string (e.g. upi://pay?pa=...&pn=... etc.)
    const decryptedUrl = decryptURL(encryptedData);
    console.log("Decrypted URL:", decryptedUrl);

    if (!decryptedUrl) return;

    // Extract query params from decrypted URL
    const urlObj = new URL(decryptedUrl);
    const params = urlObj.searchParams;

    setUpiParams({
      pa: params.get("pa") || "",
      pn: params.get("pn") || "",
      am: params.get("am") || "",
      mc: params.get("mc") || "",
      tr: params.get("tr") || "",
      tn: params.get("tn") || "",
      cu: params.get("cu") || "INR", // default INR
    });
  }, [encryptedData]);

  const { pa, pn, am, mc, tr, tn, cu } = upiParams;

  const upiUrl = `upi://pay?pa=${encodeURIComponent(pa)}&pn=${encodeURIComponent(
    pn
  )}&am=${encodeURIComponent(am)}&mc=${encodeURIComponent(
    mc
  )}&tr=${encodeURIComponent(tr)}&tn=${encodeURIComponent(
    tn
  )}&cu=${encodeURIComponent(cu)}`;

  const handlePaymentClick = () => {
    window.location.href = upiUrl;
  };

  if (!encryptedData) {
    return <p>No payment data found.</p>;
  }

  if (!pa) {
    return <p>Loading or invalid payment data...</p>;
  }

  return (
    <div style={{ fontFamily: "Arial", textAlign: "center", padding: "40px" }}>
      <img
        src="https://stucred.com/logo.png"
        alt="StuCred Logo"
        style={{ maxWidth: "200px", marginBottom: "30px" }}
        onError={(e) => (e.target.style.display = "none")}
      />
      <h1 style={{ color: "#2C3E50" }}>StuCred Payment</h1>
      <h2 style={{ marginBottom: "40px" }}>
        Pay <strong>₹{am}</strong> via UPI
      </h2>
      <button
        onClick={handlePaymentClick}
        style={{
          backgroundColor: "#0f9d58",
          color: "#fff",
          padding: "14px 28px",
          fontSize: "18px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        Pay with UPI
      </button>
      <p style={{ marginTop: "30px", fontSize: "14px", color: "#7f8c8d" }}>
        Secure payment powered by UPI. Transaction ID: {tr}
      </p>
    </div>
  );
};

export default UpiPaymentPage;
